import {
    HiChevronDoubleDown,
    HiChevronDoubleUp,
    HiMenuAlt4,
} from "react-icons/hi";

/**
 * Fallback priorities used by the shared TaskCardItem when a module
 * does not pass its own priorities map.
 */
export const DEFAULT_TASK_PRIORITIES = {
    low: {
        title: "Low",
        color: "#1CBB8C",
        icon: <HiChevronDoubleDown />,
    },
    medium: {
        title: "Medium",
        color: "#FCC34B",
        icon: <HiMenuAlt4 />,
    },
    high: {
        title: "High",
        color: "#DC3545",
        icon: <HiChevronDoubleUp />,
    },
};

export const DEFAULT_SORT_OPTIONS = [
    {
        id: "priority",
        title: "Priority",
    },
    {
        id: "deadline",
        title: "Deadline",
    },
];
